
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-estate-guides/[slug]",
      function () {
        return require("private-next-pages/real-estate-guides/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-estate-guides/[slug]"])
      });
    }
  